// import Calendar from "../../components/calendar/Calendar";
const CalendarPage = () => {
  return (
    <h2 className="dark:text-white text-xl flex justify-center items-center h-2/3">
      Coming soon!
    </h2>
  );
};

export default CalendarPage;
